import axios from 'axios';

import {
  IAttachmentUploadUrlResponse,
  IUploadedAttachment,
} from './attachment-upload.interface';

// Files never pass through our backend: ask it for a signed upload URL, then
// PUT the raw bytes straight to Google Cloud Storage. No Authorization header
// on the PUT — the signature in the URL is the credential, and a bearer token
// would break it.
async function uploadAttachmentToStorage(
  file: File,
  requestUploadUrl: (
    fileName: string,
    contentType: string,
  ) => Promise<IAttachmentUploadUrlResponse>,
  signal?: AbortSignal,
): Promise<IUploadedAttachment> {
  const { uploadUrl, storageKey, fileName, contentType } = await requestUploadUrl(
    file.name,
    file.type,
  );

  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': contentType },
    signal,
  });

  return { storageKey, fileName };
}

export { uploadAttachmentToStorage };
